import useSWR from 'swr';
import api from 'utils/api';

// ===== Admin Collab Club metrics types (GET /admin/cc-metrics) =====
// All-time, unscoped totals for the admin dashboard stat cards.
// Co-located here because they describe this endpoint's response contract.

export interface CcMetrics {
  totalRequests: number;
  totalMatches: number;
  autoMatches: number;
  teamMatches: number;
}

interface UseAdminCcMetricsResult {
  metrics: CcMetrics | null;
  isLoading: boolean;
  error: any;
  refetch: () => void;
}

/**
 * All-time Collab Club metrics for the admin dashboard (GET /admin/cc-metrics).
 * No params / pagination — see backend docs/collab-club-api.md.
 */
export function useAdminCcMetrics(): UseAdminCcMetricsResult {
  const {
    data,
    error,
    mutate: refetch,
  } = useSWR<CcMetrics>('admin-cc-metrics', () => api.collabClub.getAdminMetrics(), {
    revalidateOnFocus: false,
    revalidateOnReconnect: true,
  });

  return {
    metrics: data ?? null,
    isLoading: !data && !error,
    error,
    refetch,
  };
}
